import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

type PublishGateArgs = {
    isReady: boolean;
    quotaLoading: boolean;
    canCreate?: boolean;
    quotaRefetch: () => void;
    openPublishModal: () => void;
    openPublishedSiteModal: () => void;
    closePublishModal: () => void;

    publishSite: () => Promise<any>;
};

export function usePublishGate({
    isReady,
    quotaLoading,
    canCreate,
    quotaRefetch,
    openPublishModal,
    openPublishedSiteModal,
    closePublishModal,
    publishSite,
}: PublishGateArgs) {

    const onClickPublish = useCallback(() => {
        if (!isReady || quotaLoading) return;
        quotaRefetch();


        if (canCreate === false) {
            openPublishedSiteModal();
            return;
        }

        openPublishModal();
    }, [isReady, quotaLoading, canCreate, openPublishModal, openPublishedSiteModal]);

    const onConfirmPublish = useCallback(async () => {
        setTimeout(() => {
            closePublishModal();
            quotaRefetch();
        }, 2000);



        if (quotaLoading) return;

        if (canCreate === false) {
            openPublishedSiteModal();
            return;
        }

        await publishSite();
    }, [quotaLoading, canCreate, closePublishModal, openPublishedSiteModal, publishSite]);

    return { onClickPublish, onConfirmPublish };
}
